import { Branch } from './branch';
import { Entity } from './entity';

export class TaxRegime extends Entity {
    public id: number;
    public name: string;
  }  